const onClickReadMore = (el, bind, readLess) => {
    const { text } = bind.value;

    el.textContent = text;
    el.append(' ', readLess);
}

const onClickLessMore = (el, bind, readMore) => {
    const { letterCount, wordCount, text } = bind.value;

    if (letterCount && !wordCount) {
        el.textContent = text.substring(0, letterCount) + '...'
    }

    if (!letterCount && wordCount) {
        el.textContent = text.split(' ').slice(0, wordCount - 1).join(' ') + '...';
    }

    el.append(' ', readMore);
}

export default {
    beforeMount(el, bind) {
        const { letterCount, wordCount, text } = bind.value;

        if (!text) throw new Error('[tbeReadMore] field "text" is not defined');

        if (letterCount && !wordCount) {
            if (text.length <= letterCount) {
                el.textContent = text;
                return;
            }
            el.textContent = text.substring(0, letterCount) + '...';
        }

        if (!letterCount && wordCount) {
            const words = text.split(' ');
            if (words.length <= wordCount) {
                el.textContent = text;
                return;
            }
            el.textContent = words.slice(0, wordCount - 1).join(' ') + '...';
        }

        const readMore = document.createElement('a');
        readMore.href = '#';
        readMore.text = 'Read more';

        const readLess = document.createElement('a');
        readLess.href = '#';
        readLess.text = 'Read less';

        el.append(' ', readMore);

        readMore.addEventListener("click", onClickReadMore.bind(null, el, bind, readLess));
        readLess.addEventListener("click", onClickLessMore.bind(null, el, bind, readMore));
    },
    unmounted (el) {

    }
}
